const r=(r,t,e)=>{if(!t)return;const a=Array.isArray(t)?t:t.match(/([^[.\]])+/g),n=null==a?void 0:a.reduce((r,t)=>r&&r[t],r);return void 0===n?e:n};export{r as default};
